import axios, { AxiosError, Method } from 'axios';

type OptionsType = {
  method: Method;
  url: string;
  contentType?: 'json' | 'form-data';
  params?: any;
  data?: any;
  includeToken?: boolean;
};

export function handleError(error: AxiosError) {
  return Promise.reject(error);
}

// Formate Request Options
export function requestOptions(
  method: OptionsType['method'],
  url: OptionsType['url'],
  params: OptionsType['params'],
  contentType: OptionsType['contentType'],
  data: OptionsType['data'],
  includeToken: OptionsType['includeToken'],
) {
  const options = {
    data,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    method,
    params,
    url,
    withCredentials: includeToken, // To send cookie
  };
  if (method !== 'POST' && method !== 'PUT' && params) {
    options.params = params;
  } else if (contentType === 'json') {
    options.headers['Content-Type'] = 'application/json';
    options.params = '';
    options.data = params;
  } else if (contentType === 'form-data') {
    options.headers['Content-Type'] = 'multipart/form-data';
    options.data = params;
  } else {
    options.data = params;
  }
  return options;
}

// Common Request
export const request = async (options: OptionsType) => {
  try {
    const res = await axios(
      requestOptions(
        options.method,
        options.url,
        options.params,
        options.contentType,
        options.data,
        options.includeToken,
      ),
    );
    return res?.data;
  } catch (error: any) {
    return await handleError(error?.response ?? error);
  }
};

export const getBaseUrl = () => import.meta.env.VITE_API_BASE_URL;
